export const scrollToElement = (
  el,
  { offset, scrollingElement, ...options } = {}
) => {
  if (!el) return
  const defaultOptions = { behavior: 'smooth' }
  if (offset === undefined) {
    el.scrollIntoView?.({ ...defaultOptions, ...options })
  } else {
    if (!scrollingElement) {
      scrollingElement = document.scrollingElement
    }
    const pRect = scrollingElement.getBoundingClientRect()
    const cRect = el.getBoundingClientRect()
    const scrollTop = scrollingElement.scrollTop
    const startPosition = cRect.top - pRect.top + scrollTop - offset
    let position = startPosition
    if (options.block === 'nearest') {
      const styles = window.getComputedStyle(scrollingElement)
      const endPosition =
        cRect.bottom -
        pRect.top -
        scrollingElement.clientHeight +
        parseFloat(styles.paddingTop) +
        parseFloat(styles.paddingBottom)
      if (scrollTop <= startPosition && scrollTop >= endPosition) {
        return
      }
      // if (scrollTop <= endPosition) {
      //   position = endPosition
      // }
    }
    scrollToSmoothly(scrollingElement, position, 250)
  }
}

const scrollToSmoothly = (el, pos, time) => {
  var currentPos = el.scrollTop
  var start = null
  if (time === undefined) time = 500
  ;(pos = +pos), (time = +time)
  window.requestAnimationFrame(function step(currentTime) {
    start = !start ? currentTime : start
    var progress = currentTime - start
    if (currentPos < pos) {
      el.scrollTo(0, ((pos - currentPos) * progress) / time + currentPos)
    } else {
      el.scrollTo(0, currentPos - ((currentPos - pos) * progress) / time)
    }
    if (progress < time) {
      window.requestAnimationFrame(step)
    } else {
      el.scrollTo(0, pos)
    }
  })
}
